import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchHero } from "../services"; // Importar la función para hacer la petición

// Thunk asíncrono para obtener los datos de hero desde la API
export const fetchHeroData = createAsyncThunk("hero/fetchHeroData", async (_, { rejectWithValue }) => {
  try {
    const data = await fetchHero(); // Llama al servicio de la API
    return data;
  } catch (error) {
    return rejectWithValue(error.message); // Manejo de errores
  }
});

const heroSlice = createSlice({
  name: "hero",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Puedes agregar más acciones sincronas si es necesario
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeroData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHeroData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchHeroData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default heroSlice.reducer;
